export default {
	tasks(state) {
		return state._tasks
	}
}